/* ░░ SOLAR — app.js ░░ */
(() => {
  const P = (window.SOLAR_PRODUCTS || []);
  let hombreSet = new Set();   /* handles de la colección "Hombre" de Shopify (en vivo) */
  const hombre3 = {};          /* handle → 3ª foto EN VIVO (regla: 3ª foto = modelo hombre) */
  /* REGLA SIMPLE (la que pidió Jesu): el filtro toma la colección de Shopify; el hover usa la posición de foto:
     - filtro Hombre  → 3ª foto (Jesu SIEMPRE pone un hombre en la 3ª foto).
     - filtro Mujer   → 2ª foto (Jesu SIEMPRE pone una mujer en la 2ª foto).
     Excepción temporal: estos productos están en la colección Hombre pero su 3ª foto AÚN es de mujer
     (Jesu todavía no les sube foto de hombre). Mientras tanto NO cambian en hover (se quedan en la foto 1),
     para no mostrar una mujer en el filtro Hombre. Cuando Jesu les suba la foto de hombre como 3ª, se quita de aquí. */
  const HOMBRE_3ES_MUJER = new Set(['sundown','sunlit','luminescence','lunoir','night-dust','cosmic-stripe']);
  /* ── DATOS EN VIVO desde Shopify (precio/stock/variant) — solo en el theme de Shopify ── */
  if (window.SOLAR_LIVE) {
    const live = window.SOLAR_LIVE;
    for (let i = P.length - 1; i >= 0; i--) {
      const L = live[P[i].handle];
      if (!L) { P.splice(i, 1); continue; } /* no activo en Shopify → quitar del catálogo */
      P[i].price = L.price;
      P[i].compareAt = L.compareAt || 0;
      if (L.vid) P[i].vid = L.vid;
      P[i].available = L.available;
      if (typeof L.polarized === 'boolean') P[i].polarized = L.polarized; /* polarizados desde colección Shopify */
      if (typeof L.man === 'boolean') P[i].isMan = L.man;
      if (typeof L.woman === 'boolean') P[i].inMujer = L.woman; /* membresía colección "Mujer" de Shopify (en vivo) */
      /* NO sobreescribir las fotos con la data en vivo: all_products devuelve imágenes
         equivocadas/genéricas para ~62 productos. Se usan las fotos curadas (correctas). */
    }
    /* añadir productos en vivo que no están en el catálogo curado (ej: polarizados extra) */
    const have = new Set(P.map(x => x.handle));
    for (const h in live) {
      const L = live[h];
      if (!have.has(h) && L && L.title) {
        P.push({ id: L.vid || ('x' + h), handle: h, title: L.title,
          price: L.price, compareAt: L.compareAt || 0,
          img: L.img, img2: L.img2 || L.img, img3: L.img3, isMan: !!L.man, inMujer: !!L.woman, images: [L.img, L.img2, L.img3].filter(Boolean),
          gender: L.gender || '', genders: L.gender ? [L.gender] : [],
          forma: [], colorMarco: [], colorLente: [], uso: [],
          optical: !!L.optical, bluelight: false, polarized: !!L.polarized,
          daily: false, season: false, cheap: false,
          available: L.available, vid: L.vid, desc: '', url: '/products/' + h });
      }
    }
  }
  /* ── COLECCIÓN HOMBRE (en vivo, recorriendo la colección de Shopify = confiable) ──
     El filtro "Hombre" del catálogo muestra EXACTAMENTE estos productos, y su hover usa la 3ª foto. */
  if (Array.isArray(window.SOLAR_HOMBRE)) {
    hombreSet = new Set(window.SOLAR_HOMBRE.map(h => h.handle));
    const have2 = new Set(P.map(x => x.handle));
    window.SOLAR_HOMBRE.forEach(h => {
      /* 3ª foto EN VIVO de la colección Hombre = la del modelo hombre (regla simple).
         Salvo las que todavía tienen mujer en la 3ª foto → esas no entran (se quedan en foto 1). */
      if (h.img3 && !HOMBRE_3ES_MUJER.has(h.handle)) hombre3[h.handle] = h.img3;
      if (have2.has(h.handle)) {
        /* Ya está en el catálogo: corregimos precio/stock/variante con el dato CONFIABLE del loop de
           colección. all_products/SOLAR_LIVE a veces entrega precios VIEJOS cacheados → desajuste
           (ej: foto $69.990 pero el real es $119.990). El loop de colección sí trae el precio real. */
        const ex = P.find(x => x.handle === h.handle);
        if (ex) {
          if (typeof h.price === 'number') ex.price = h.price;
          if (typeof h.compareAt === 'number') ex.compareAt = h.compareAt || 0;
          if (h.vid) ex.vid = h.vid;
          if (typeof h.available === 'boolean') ex.available = h.available;
        }
      } else if (h.title) {
        /* producto de la colección Hombre que NO está en el catálogo curado → lo agregamos */
        P.push({ id: h.vid || ('h' + h.handle), handle: h.handle, title: h.title,
          price: h.price, compareAt: h.compareAt || 0,
          img: h.img, img2: h.img2 || h.img, img3: h.img3, images: [h.img, h.img2, h.img3].filter(Boolean),
          gender: 'Hombre', genders: ['Hombre'],
          forma: [], colorMarco: [], colorLente: [], uso: [],
          optical: false, bluelight: false, polarized: false, daily: false, season: false, cheap: false,
          available: h.available, vid: h.vid, desc: '', url: '/products/' + h.handle });
      }
    });
  }
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const clp = (n) => '$' + Number(n).toLocaleString('es-CL');
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ── LOGO: usa https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-logo-blanco.png + logo-negro.png si existen ── */
  (function initLogo() {
    const probe = new Image();
    probe.onload = () => {
      document.body.classList.add('has-logo');
      $$('.nav__logo,.loader__mark,.footer__mark').forEach(el =>
        el.innerHTML = '<img class="logo-img logo-w" src="https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-logo-blanco.png" alt="SOLAR co"><img class="logo-img logo-b" src="https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-logo-negro.png" alt="SOLAR co">');
      $$('.footer__big').forEach(el =>
        el.innerHTML = '<img class="footer__biglogo" src="https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-logo-blanco.png" alt="" />');
    };
    probe.src = 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-logo-negro.png';
  })();

  /* ── ENTRADA DIRECTA (se eliminó el loader 0→100% que hacía perder ~2s) ── */
  const loader = $('#loader');
  if (loader) loader.remove();
  setTimeout(boot, 0); /* boot en el próximo tick: ya corrió el IIFE y 'render' está asignado */

  /* ── NAV ── */
  const nav = $('#nav');
  /* En páginas SIN hero (colección/producto, sin #grid) el nav va siempre sólido (oscuro), si no quedaría blanco invisible. */
  const onScroll = () => nav.classList.toggle('solid', !document.getElementById('grid') || scrollY > innerHeight * .7);
  addEventListener('scroll', onScroll); onScroll();
  const burger = $('#burger'), menu = $('#menu');
  burger.addEventListener('click', () => { menu.classList.toggle('open'); burger.classList.toggle('on'); });
  $$('#menu a').forEach(a => a.addEventListener('click', () => menu.classList.remove('open')));

  /* ── WhatsApp cotización óptica ── */
  const WA = 'https://wa.me/56962187892?text=' + encodeURIComponent('Hola! Quisiera cotizar mis ópticos. Te envío mi receta y el anteojo que me gustó.\n\nLo quiero con tratamiento:\nA) Orgánico Capa (antirreflejo)\nB) Orgánico Blue (computador / luz azul)\nC) Orgánico Fotocromático (se oscurece con los rayos UV)\n\n— Elige una de estas tres opciones.');
  $$('[data-wa]').forEach(a => { a.href = WA; a.target = '_blank'; a.rel = 'noopener'; });

  /* ── FILTER STATE ── */
  const state = { base: 'all', forma: new Set(), color: new Set(), sort: 'best', query: '' };
  /* texto buscable de un producto (sin tildes): nombre + forma + color + uso + tipo */
  const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(new RegExp('[\u0300-\u036f]','g'), '');
  const searchText = (p) => {
    if (p._s == null) p._s = norm([p.title, (p.forma || []).join(' '), (p.colorMarco || []).join(' '),
      (p.colorLente || []).join(' '), (p.uso || []).join(' '), (p.genders || []).join(' '),
      p.optical ? 'optico optica receta' : 'sol', p.polarized ? 'polarizado' : '', p.bluelight ? 'azul computador' : ''].join(' '));
    return p._s;
  };
  const qMatch = (p) => {
    const q = norm(state.query).trim();
    if (!q) return true;
    return q.split(/\s+/).every(tok => searchText(p).includes(tok));
  };
  const baseMatch = (p) => {
    switch (state.base) {
      case 'all': return true;
      /* Mujer = estar en la colección "Mujer" de Shopify (membresía EN VIVO, flag woman del snippet).
         Los unisex están en Hombre Y Mujer → aparecen en ambos filtros (en Mujer su hover es la 2ª foto).
         Respaldo a género curado si no hay datos en vivo (sitio estático sin Shopify). */
      case 'mujer': return (typeof p.inMujer === 'boolean') ? p.inMujer : (p.genders || [p.gender]).includes('Mujer');
      case 'hombre': return hombreSet.size ? hombreSet.has(p.handle) : (p.genders || [p.gender]).includes('Hombre');
      case 'unisex': return (p.genders || []).includes('Hombre') && (p.genders || []).includes('Mujer');
      case 'sol': return !p.optical;
      case 'optical': return p.optical;
      case 'polarized': return p.polarized;
      case 'bluelight': return p.bluelight;
      default: return true;
    }
  };
  const matches = (p) =>
    baseMatch(p) &&
    qMatch(p) &&
    (state.forma.size === 0 || p.forma.some(f => state.forma.has(f))) &&
    (state.color.size === 0 || p.colorMarco.some(c => state.color.has(c)));
  const list = () => {
    let arr = P.filter(matches);
    if (state.sort === 'price-asc') arr = [...arr].sort((a, b) => a.price - b.price);
    else if (state.sort === 'price-desc') arr = [...arr].sort((a, b) => b.price - a.price);
    return arr; // 'best' = orden por ventas reales (Shopify)
  };

  /* ── CARD ── */
  const cardHTML = (p) => {
    const sale = p.compareAt > p.price;
    const soldout = p.available === false;
    const url = `/products/${p.handle}`;
    /* Hover por FILTRO (regla simple de Jesu):
       - "Hombre" → 3ª foto EN VIVO de la colección (modelo hombre). Si esa 3ª foto aún es mujer
         (set HOMBRE_3ES_MUJER) o no existe → se queda en la foto 1 (no cambia, nunca mujer).
       - "Mujer"/otros → 2ª foto (modelo mujer). */
    const manImg = hombre3[p.handle];
    const hov = (state.base === 'hombre') ? (manImg || p.img) : (p.img2 || p.img);
    return `<div class="card ${soldout ? 'card--soldout' : ''}" data-id="${p.id}">
      <div class="card__media" data-href="${url}">
        ${soldout ? '<span class="card__tag card__tag--out">Agotado</span>' : (sale ? `<span class="card__tag card__tag--sale">-${Math.round((1 - p.price / p.compareAt) * 100)}%</span>` : '')}
        <img class="a" src="${p.img}" alt="${p.title}" loading="lazy" />
        <img class="b" src="${hov}" alt="" loading="lazy" />
        <div class="card__actions">
          <a class="card__act card__view" href="${url}">Ver</a>
          <button class="card__act card__try" type="button" data-try="${p.id}">Probar</button>
          ${soldout ? '<span class="card__act card__add card__add--off">Agotado</span>' : `<button class="card__act card__add card__add--icon" type="button" data-add="${p.id}" aria-label="Agregar al carrito"><span>+</span><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.2 11.2a1.6 1.6 0 0 0 1.6 1.3h8a1.6 1.6 0 0 0 1.6-1.3L21 7H6"/></svg></button>`}
        </div>
      </div>
      <a class="card__info" href="${url}">
        <div class="card__name">${p.title}</div>
        <div class="card__meta">
          <span class="card__price">${sale ? `<s>${clp(p.compareAt)}</s><b class="now">${clp(p.price)}</b>` : `<b>${clp(p.price)}</b>`}</span>
        </div>
      </a>
    </div>`;
  };

  /* ── CATALOG RENDER ── */
  const grid = $('#grid');
  let render = null; /* se asigna dentro de if(grid); boot() lo llama de forma segura */
  let opticaRerender = null; /* se asigna dentro de if(grid); para re-render tras traer precios reales */
  /* Todo lo que sigue (catálogo, filtros, óptica, colecciones, ocasión, reels, split) es de la
     PÁGINA PRINCIPAL. En páginas de colección/producto no existe #grid → se omite para no romper.
     El carrito lateral y los handlers universales (más abajo) SÍ corren en todas las páginas. */
  if (grid) {
  let shown = 0; const STEP = 16;
  render = (reset = false) => {
    if (reset) { grid.innerHTML = ''; shown = 0; }
    const items = list().slice(shown, shown + STEP);
    items.forEach((p, i) => {
      const el = document.createElement('div'); el.innerHTML = cardHTML(p);
      const card = el.firstElementChild; grid.appendChild(card);
      requestAnimationFrame(() => setTimeout(() => card.classList.add('in'), i * 40));
    });
    shown += items.length;
    $('#loadMore').style.display = shown < list().length ? '' : 'none';
    if (!list().length) grid.innerHTML = state.query
      ? `<p class="grid__empty">No encontramos “${state.query}”. Prueba otro nombre, forma o color.</p>`
      : '<p class="grid__empty">No hay modelos con esos filtros.</p>';
  };
  $('#loadMore').addEventListener('click', () => render(false));

  /* ── BUSCADOR (nav + sección 3 + sección 7) ── */
  const scrollToCatalog = () => {
    const y = $('#catalogo').getBoundingClientRect().top + scrollY - 8;
    if (window.__lenis) window.__lenis.scrollTo(y); else scrollTo({ top: y, behavior: 'smooth' });
  };
  const searchInputs = ['#navSearch', '#catSearch', '#ocasionSearch'].map(s => $(s)).filter(Boolean);
  const setQuery = (q, fromEl) => {
    state.query = q;
    render(true);
    searchInputs.forEach(inp => { if (inp !== fromEl && inp.value !== q) inp.value = q; }); /* sincroniza los demás */
  };
  searchInputs.forEach(inp => {
    const scrollOnType = inp.id !== 'catSearch'; /* nav y ocasión llevan al catálogo; el de la sección 3 ya está ahí */
    inp.addEventListener('input', () => {
      const had = !!state.query;
      setQuery(inp.value.trim(), inp);
      if (scrollOnType && !had && state.query) scrollToCatalog();
    });
    inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); if (scrollOnType) scrollToCatalog(); inp.blur(); } });
  });

  /* ── QUICK FILTERS (género/uso) ── */
  $$('#filters .filter').forEach(b => b.addEventListener('click', () => {
    $$('#filters .filter').forEach(x => x.classList.remove('is-active'));
    b.classList.add('is-active'); state.base = b.dataset.filter; render(true); syncFilterUI();
  }));

  /* ── FILTER PANEL (forma + color) ── */
  const formaList = [...new Set(P.flatMap(p => p.forma))].filter(Boolean)
    .sort((a, b) => P.filter(p => p.forma.includes(b)).length - P.filter(p => p.forma.includes(a)).length);
  const colorCount = (c) => P.filter(p => p.colorMarco.includes(c)).length;
  const colorList = [...new Set(P.flatMap(p => p.colorMarco))].filter(c => c && colorCount(c) >= 2)
    .sort((a, b) => colorCount(b) - colorCount(a));
  const COLORDOT = { 'Negro': '#1a1a1a', 'Café': '#6b4a2b', 'Leopardo': '#b07a3a', 'Dorado': '#c9a24b', 'Plateado': '#c8c8cc', 'Gris': '#8a8a8a', 'Verde': '#3f5a3a', 'Azul': '#3a5a8a', 'Rosado': '#d79bb0', 'Rojo': '#9a3b34', 'Blanco': '#f2efe8', 'Transparente': 'linear-gradient(135deg,#eee,#cfd2d6)', 'Celeste': '#9bc3d7', 'Menta': '#bcd9c9', 'Animal Print': '#b07a3a', 'Leopardo y Negro': '#7a5a2a' };
  const dot = (c) => `<span class="cdot" style="background:${COLORDOT[c] || '#bbb'}"></span>`;
  $('#fForma').innerHTML = formaList.map(f => `<button class="chip" data-g="forma" data-v="${f}">${f}</button>`).join('');
  $('#fColor').innerHTML = colorList.map(c => `<button class="chip" data-g="color" data-v="${c}">${dot(c)}${c}</button>`).join('');

  const filterPanel = $('#filterPanel'), filterToggle = $('#filterToggle'), filterClear = $('#filterClear'), filterCount = $('#filterCount');
  filterToggle.addEventListener('click', () => filterPanel.hidden = !filterPanel.hidden);
  filterClear.addEventListener('click', () => { state.forma.clear(); state.color.clear(); render(true); syncFilterUI(); });
  $$('#fForma .chip, #fColor .chip').forEach(ch => ch.addEventListener('click', () => {
    const set = ch.dataset.g === 'forma' ? state.forma : state.color;
    const v = ch.dataset.v; set.has(v) ? set.delete(v) : set.add(v);
    render(true); syncFilterUI();
  }));
  // orden (precio / más vendidos) — selección única
  $$('#fSort .chip').forEach(ch => ch.addEventListener('click', () => {
    state.sort = ch.dataset.sort;
    $$('#fSort .chip').forEach(x => x.classList.toggle('on', x === ch));
    render(true);
  }));
  function syncFilterUI() {
    $$('#fForma .chip, #fColor .chip').forEach(ch => {
      const set = ch.dataset.g === 'forma' ? state.forma : state.color;
      ch.classList.toggle('on', set.has(ch.dataset.v));
    });
    const n = state.forma.size + state.color.size;
    filterCount.textContent = n ? `${n} filtro${n > 1 ? 's' : ''}` : '';
    filterClear.hidden = n === 0;
  }

  /* ── APLICAR FILTRO DESDE "PARA CADA OCASIÓN" ── */
  function applyShop(type, value) {
    if (type === 'uso') {
      state.base = value;
      $$('#filters .filter').forEach(x => x.classList.toggle('is-active', x.dataset.filter === value));
    } else if (type === 'forma') {
      state.forma = new Set([value]); filterPanel.hidden = false;
    } else if (type === 'color') {
      state.color = new Set([value]); filterPanel.hidden = false;
    }
    render(true); syncFilterUI();
    const y = $('#catalogo').getBoundingClientRect().top + scrollY - 10;
    if (window.__lenis) window.__lenis.scrollTo(y); else scrollTo({ top: y, behavior: 'smooth' });
  }

  /* ── SHOP BY (forma/uso/color chips en "Para cada ocasión") ── */
  const topForma = formaList.slice(0, 7);
  const usos = [['sol', 'Sol', '/collections/frontpage'], ['optical', 'Ópticos', '/collections/lentes-opticos'], ['polarized', 'Polarizados', '/collections/polarizados'], ['bluelight', 'Computador', '/collections/para-el-compu'], ['fiesta', 'Fiesta', '/collections/fiestas'], ['elegante', 'Elegantes', '/collections/elegantes'], ['vintage', 'Vintage', '/collections/vintage-1'], ['european', 'European Style', '/collections/fall-season-1'], ['timeless', 'Timeless', '/collections/timeless'], ['fashion', 'Fashion', '/collections/fashion'], ['urban', 'Urban', '/collections/urban']];
  const topColor = colorList.slice(0, 8);
  /* mapeo forma/color → colecciones reales de Shopify (fallback al catálogo) */
  const FORMA_COL = {'Aviador':'aviador','Cat Eye':'cat-eye','Cuadrado':'cuadrados','Cuadrados':'cuadrados','Ovalado':'ovalados','Rectangular':'rectangulares','Redondo':'redondos','Hexagonal':'hexagonales','Pentágono':'pentagonal','Pentagonal':'pentagonal'};
  const COLOR_COL = {'Negro':'negro','Café':'cafe','Gris':'gris','Verde':'verde','Azul':'azul','Rojo':'rojo','Rosado':'rosado','Blanco':'blanco','Leopardo':'leopardo','Amarillo':'amarillo','Naranjo':'naranjo'};
  const colHref = (handle) => handle ? ('/collections/' + handle) : '#catalogo';
  $('#shopForma').innerHTML = topForma.map(f => `<a class="chip" href="${colHref(FORMA_COL[f])}">${f}</a>`).join('');
  $('#shopUso').innerHTML = usos.map(([k, l, href]) => `<a class="chip" href="${href}">${l}</a>`).join('');
  $('#shopColor').innerHTML = topColor.map(c => `<a class="chip" href="${colHref(COLOR_COL[c])}">${dot(c)}${c}</a>`).join('');
  /* desplegable de filtros de la sección 7 (cerrado por defecto) */
  const ocaShopToggle = $('#ocasionShopToggle'), ocaShopWrap = $('#ocasionShopWrap');
  if (ocaShopToggle && ocaShopWrap) ocaShopToggle.addEventListener('click', () => {
    const open = !ocaShopWrap.classList.contains('is-open');
    ocaShopWrap.classList.toggle('is-open', open);
    ocaShopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── COLECCIONES (con personas reales) ── */
  const COLS = [
    { t: 'Snow Season', s: 'Antiparras para la nieve', k: 'snow', h: 'antiparras', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-snow.jpg?v=3', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-snow.jpg?v=3', pos: 'center' },
    { t: 'Daily Icons', s: 'Lo último que llegó', k: 'daily', h: 'daily-icons', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-daily.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f2-02.jpg', pos: 'center 47%' },
    { t: 'Solar Season 2026', s: 'La nueva colección', k: 'season', h: 'solar-season-2026', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-season.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f2-01.jpg', pos: 'center 38%' },
    { t: 'Best Sellers', s: 'Los más deseados', k: 'best', h: 'best-sellers', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-best.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-campaign-01.jpg' },
    { t: 'Polarizados', s: 'Visión sin reflejos', k: 'polarized', h: 'best-sellers', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-polarizados.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f2-03.jpg' },
    { t: 'Hombres', s: 'La mejor selección para ellos', k: 'hombre', h: 'hombre', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-diadelpadre.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-diadelpadre.jpg', pos: 'center 20%' },
    { t: 'Óptica a medida', s: 'Lentes con tu receta', k: 'optical', h: 'lentes-opticos', custom: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-col-optica.jpg', img: 'https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f3-01.jpg', pos: 'center 72%' },
  ];
  /* 'snow' = antiparras: viven solo en Shopify (colección "antiparras"), no en el catálogo estático */
  const colCount = (k) => k === 'snow' ? 4 : P.filter(x => k === 'best' ? true : k === 'hombre' ? (hombreSet.size ? hombreSet.has(x.handle) : (x.genders || [x.gender]).includes('Hombre')) : k === 'optical' ? x.optical : k === 'polarized' ? x.polarized : k === 'season' ? x.season : x.daily).length;
  const colTrackEl = $('#colTrack');
  /* Si Shopify ya renderizó las cápsulas (bloques editables), no las sobreescribimos */
  if (colTrackEl && colTrackEl.children.length === 0) {
    colTrackEl.innerHTML = COLS.map((c, i) =>
    `<a class="col-card" href="/collections/${c.h}">
      <span class="col-card__idx">0${i + 1}</span><span class="col-card__count">${colCount(c.k)} modelos</span>
      <img src="${c.custom}" onerror="this.onerror=null;this.src='${c.img}'" alt="${c.t}" loading="lazy" style="object-position:${c.pos || 'center'}" />
      <div class="col-card__body"><h3>${c.t}</h3><p>${c.s}</p><span class="link">EXPLORAR <span>↗</span></span></div>
    </a>`).join('');
  }
  const vp = $('#colViewport');
  let down = false, startX, sl;
  vp.addEventListener('pointerdown', e => { down = true; startX = e.pageX; sl = vp.scrollLeft; });
  addEventListener('pointerup', () => down = false);
  vp.addEventListener('pointermove', e => { if (down) vp.scrollLeft = sl - (e.pageX - startX); });

  /* ── ÓPTICA grid + su propio buscador (sección 6) ── */
  const opticaGrid = $('#opticaGrid');
  let opticaQ = '';
  const renderOptica = () => {
    const q = norm(opticaQ).trim();
    let arr = P.filter(p => p.optical);
    if (q) arr = arr.filter(p => q.split(/\s+/).every(t => searchText(p).includes(t)));
    const items = q ? arr : arr.slice(0, 10); /* sin búsqueda muestra 10; buscando muestra todos los que calzan */
    opticaGrid.innerHTML = items.length
      ? items.map(cardHTML).join('')
      : `<p class="grid__empty">No encontramos “${opticaQ}” en ópticos.</p>`;
    $$('#opticaGrid .card').forEach((c, i) => setTimeout(() => c.classList.add('in'), i * 40));
  };
  renderOptica();
  opticaRerender = renderOptica;
  const opticaSearch = $('#opticaSearch');
  if (opticaSearch) opticaSearch.addEventListener('input', () => { opticaQ = opticaSearch.value.trim(); renderOptica(); });

  /* ── OCASIÓN collage (personas) — masonry, flip cards ── */
  const models = ['f3-01', 'f2-01', 'occ-1', 'f3-02', 'f1-03', 'occ-3', 'f3-03', 'f1-01', 'occ-5', 'f3-04', 'occ-2', 'campaign-01', 'f2-04', 'occ-4', 'f1-02', 'occ-7'];
  /* Anteojo(s) por foto, en el orden del collage (4 por fila, posición 1..20).
     Mapeo dado por Jesu foto por foto. 'Lune Black' no existe → usamos Lune Smoke (confirmar). */
  const OCC_GLASSES = [
    ['Nova Night'],                   // 1  hombre
    ['Lune Smoke'],                   // 2  mujer
    ['Mega Leopard'],                 // 3  mujer de rojo
    ['Mega Black'],                   // 4  hombre
    ['Vision Dust'],                  // 5
    ['BLAZE LEOPARD'],                // 6
    ['Nova Sky', 'Nebulon Black'],    // 7  dos hombres
    ['Lune Amber'],                   // 8
    ['Mega Black'],                   // 9
    ['SUNWAVE BLACK'],                // 10
    ['Lune Moss'],                    // 11
    ['Mega Red'],                     // 12
    ['Lune Moss'],                    // 13
    ['Vision Dust'],                  // 14
    ['Mega Leopard'],                 // 15
    ['VISION BROWN']                  // 16
  ];
  const occByTitle = (t) => P.find(p => p.title.toLowerCase() === t.toLowerCase());
  $('#ocasionGrid').innerHTML = models.map((m, i) => {
    const prods = (OCC_GLASSES[i] || []).map(occByTitle).filter(Boolean);
    const back = prods.length
      ? `<div class="ed__cards ${prods.length > 1 ? 'ed__cards--multi' : ''}">` + prods.map(p => `<div class="ed__card">
          <div class="ed__cardimg"><img src="${p.img}" alt="${p.title}" /></div>
          <div class="ed__pn">${p.title}</div>
          <div class="ed__pp">${clp(p.price)}</div>
          <div class="ed__cardbtns">
            <button class="ed__btn ed__btn--try" type="button" data-try="${p.id}">Probar</button>
            <button class="ed__btn ed__btn--add" type="button" data-add="${p.id}">Agregar</button>
          </div>
        </div>`).join('') + `</div>`
      : `<a class="ed__prod ed__prod--soon" href="#catalogo"><span class="ed__pn">Ver el look</span><span class="ed__pv">Explorar →</span></a>`;
    return `<figure class="ed flip" data-key="${m}">
      <div class="ed__inner">
        <div class="ed__face ed__front"><img src="https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-${m}.jpg?v=2" alt="" loading="lazy"/><span class="ed__hint">＋</span></div>
        <div class="ed__face ed__back">${back}</div>
      </div>
    </figure>`;
  }).join('');
  $('#ocasionGrid').addEventListener('click', (e) => {
    const tryBtn = e.target.closest('[data-try]');
    if (tryBtn) { e.stopPropagation(); if (window.solarQuickTryOn) window.solarQuickTryOn(+tryBtn.dataset.try); return; }
    const addBtn = e.target.closest('[data-add]');
    if (addBtn) { e.stopPropagation(); const p = P.find(x => x.id === +addBtn.dataset.add); if (p) { addToCart(p, p.price); openCart(); } return; }
    if (e.target.closest('a')) return; /* dejar navegar enlaces */
    const fig = e.target.closest('.ed.flip');
    if (fig) fig.classList.toggle('flipped');
  });

  /* ── SPLIT bg (encuadre: bajamos las fotos para centrar las caras) ── */
  Object.assign($('#splitMujer').style, { backgroundImage: "url(https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f2-04.jpg)", backgroundPosition: "center 30%" });
  Object.assign($('#splitHombre').style, { backgroundImage: "url(https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-campaign-f3-01.jpg)", backgroundPosition: "center 16%" });
  $$('.split__half').forEach(h => h.addEventListener('click', (e) => {
    e.preventDefault();
    const btn = $(`#filters .filter[data-filter="${h.dataset.gender}"]`);
    if (btn) btn.click();
    const y = $('#catalogo').getBoundingClientRect().top + scrollY - 10;
    if (window.__lenis) window.__lenis.scrollTo(y); else scrollTo({ top: y, behavior: 'smooth' });
  }));

  /* ── REELS ── */
  const byTitle = (t) => P.find(p => p.title.toLowerCase() === t.toLowerCase());
  const reelData = [
    { f: 'reel-1.mp4', v: '66,2 mil', shop: ['Singular Black', 'Singular Leopard', 'CENIT BLACK', 'Cosmic Black', 'SUNWAVE LEOPARD', 'LUMINESCENCE', 'SUNWAVE COFFE'] },
    { f: 'reel-6.mp4', v: '1,9 mil', shop: ['CENIT BLACK'] },
    { f: 'reel-men.mp4', v: '1,2 mil', shop: ['Sol Meridian'] },
    { f: 'reel-2.mp4', v: '53,6 mil', pos: 'center 72%', shop: ['Cosmic Black', 'Muse Gold', 'Noon', 'Haze'] },
    { f: 'reel-7.mp4', v: '1,7 mil', shop: ['BLAZE BLACK'] },
    { f: 'reel-3.mp4', v: '45,8 mil', shop: ['SUNWAVE MINT', 'MIZAR BLACK', 'Proxima Black', 'Mega Leopard', 'Mega Black', 'CENIT BLACK'] },
    { f: 'reel-5.mp4', v: '24,2 mil', shop: ['BLAZE LEOPARD'] },
  ];
  const reelShop = (r) => {
    if (r.collection) return `<a class="reel__coll" href="/collections/${r.collection}">${r.collLabel} →</a>`;
    const prods = (r.shop || []).map(byTitle).filter(Boolean);
    if (!prods.length) return '';
    const list = prods.map(p =>
      `<div class="reel__prod"><a class="reel__prodlink" href="/products/${p.handle}"><img src="${p.img}" alt=""><span class="reel__prodn">${p.title}</span><span class="reel__prodp">${clp(p.price)}</span></a><button class="reel__prodadd" type="button" data-add="${p.id}" aria-label="Agregar ${p.title}">+ Agregar</button></div>`).join('');
    return `<button class="reel__shoptoggle" type="button" aria-expanded="false">Compra el look <span class="reel__count">${prods.length}</span><i class="reel__chev">▾</i></button>
      <div class="reel__shoplist">${list}</div>`;
  };
  const rt = $('#reelsTrack');
  if (rt) {
    const SW_V = {
"reel-1.mp4": "https://cdn.shopify.com/videos/c/vp/8bb6a767b1014ef990e371740b9992a4/8bb6a767b1014ef990e371740b9992a4.HD-720p-1.6Mbps-91860397.mp4",
"reel-6.mp4": "https://cdn.shopify.com/videos/c/vp/b935e0fd0d0c4cdcb8b76db8074567bd/b935e0fd0d0c4cdcb8b76db8074567bd.HD-720p-3.0Mbps-91860398.mp4",
"reel-men.mp4": "https://cdn.shopify.com/videos/c/vp/57ebda8b0b9446c585316e17314e6f79/57ebda8b0b9446c585316e17314e6f79.HD-720p-1.6Mbps-91860399.mp4",
"reel-2.mp4": "https://cdn.shopify.com/videos/c/vp/a4a5fd74d2a242498c8ce911e4d52ca6/a4a5fd74d2a242498c8ce911e4d52ca6.HD-720p-1.6Mbps-91860400.mp4",
"reel-7.mp4": "https://cdn.shopify.com/videos/c/vp/1ee11a340ffc4858b26128c470c4f1b4/1ee11a340ffc4858b26128c470c4f1b4.HD-720p-1.6Mbps-91860401.mp4",
"reel-3.mp4": "https://cdn.shopify.com/videos/c/vp/4cd238a24b0945b0bbf39577e81f21eb/4cd238a24b0945b0bbf39577e81f21eb.HD-720p-1.6Mbps-91860402.mp4",
"reel-5.mp4": "https://cdn.shopify.com/videos/c/vp/e48b69c56cd845e19bd42deeec2a75e3/e48b69c56cd845e19bd42deeec2a75e3.HD-720p-1.6Mbps-91860403.mp4"
};
    rt.innerHTML = reelData.map(r =>
      `<div class="reelitem">
         <div class="reel"><span class="reel__views">▶ ${r.v}</span>
           <video src="${SW_V[r.f]}" poster="https://cdn.shopify.com/s/files/1/0832/2220/0593/files/sw-video-poster-${r.f.replace('.mp4', '')}.jpg" muted loop playsinline autoplay preload="auto"${r.pos ? ` style="object-position:${r.pos}"` : ''}></video>
           <span class="reel__sound">🔇</span></div>
         <div class="reel__shop">${reelShop(r)}</div>
       </div>`).join('');
    /* desplegable "Compra el look" */
    rt.addEventListener('click', (e) => {
      const add = e.target.closest('.reel__prodadd');
      if (add) { e.preventDefault(); e.stopPropagation(); const prod = P.find(x => x.id === +add.dataset.add); if (prod) { addToCart(prod, prod.price); openCart(); } return; }
      const t = e.target.closest('.reel__shoptoggle');
      if (!t) return;
      const open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!open));
      t.nextElementSibling.classList.toggle('open', !open);
    });
    const reels = $$('.reel');
    const playSafe = v => { const p = v.play(); if (p) p.catch(() => {}); };
    const rio = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target.querySelector('video');
      if (e.isIntersecting) playSafe(v); else v.pause();
    }), { threshold: .25 });
    reels.forEach(card => {
      rio.observe(card);
      const v = card.querySelector('video'), s = card.querySelector('.reel__sound');
      playSafe(v); /* intento de autoplay inmediato (iOS muted inline) */
      card.addEventListener('click', (e) => {
        if (e.target.closest('.reel__shoptoggle') || e.target.closest('.reel__prod')) return;
        reels.forEach(o => { if (o !== card) { o.querySelector('video').muted = true; o.querySelector('.reel__sound').textContent = '🔇'; } });
        v.muted = !v.muted; s.textContent = v.muted ? '🔇' : '🔊'; playSafe(v);
      });
    });
  }
  } /* ← fin del bloque if(grid) de la página principal */

  /* ── CARRITO (lateral) — UNIVERSAL: corre en home Y en páginas de colección ── */
  const cart = [];
  /* Restaurar carrito guardado para que persista entre páginas (home ↔ colección) */
  try { const saved = JSON.parse(localStorage.getItem('solar_cart') || '[]'); if (Array.isArray(saved)) saved.forEach(i => cart.push(i)); } catch (e) {}
  const cartEl = $('#cart'), cartItems = $('#cartItems'), cartUpsell = $('#cartUpsell');
  if ($('#cartCount')) $('#cartCount').textContent = cart.reduce((s, i) => s + i.qty, 0);
  const openCart = () => { if (!cartEl) return; cartEl.classList.add('open'); renderCart(); if (window.__lenis) window.__lenis.stop(); };
  const closeCart = () => { if (!cartEl) return; cartEl.classList.remove('open'); if (window.__lenis) window.__lenis.start(); };
  const _co = $('#cartOpen'); if (_co) _co.addEventListener('click', openCart);
  const _cc = $('#cartClose'); if (_cc) _cc.addEventListener('click', closeCart);
  const _cov = $('#cartOverlay'); if (_cov) _cov.addEventListener('click', closeCart);
  function saveCart() { try { localStorage.setItem('solar_cart', JSON.stringify(cart)); } catch (e) {} }
  function addToCart(prod, price) {
    const ex = cart.find(i => i.id === prod.id);
    if (ex) ex.qty++; else cart.push({ id: prod.id, vid: prod.vid, title: prod.title, img: prod.img, price, qty: 1 });
    $('#cartCount').textContent = cart.reduce((s, i) => s + i.qty, 0);
    saveCart();
  }
  // link al checkout real de Shopify con los productos cargados (cart permalink)
  function checkoutUrl() {
    cart.forEach(i => { if (!i.vid) { const p = P.find(x => x.id === i.id); if (p && p.vid) i.vid = p.vid; } });
    const items = cart.filter(i => i.vid);
    return items.length ? 'https://solarcompany.cl/cart/' + items.map(i => `${i.vid}:${i.qty}`).join(',') : 'https://www.solarcompany.cl';
  }
  function renderCart() {
    if (!cartItems || !cartUpsell) return;
    cartItems.innerHTML = cart.length ? cart.map(i =>
      `<div class="citem" style="cursor:default"><img src="${i.img}" alt=""><div class="citem__b"><b>${i.title}</b><span>${clp(i.price)} · x${i.qty}</span></div></div>`).join('')
      : '<p class="cart__empty">Tu carrito está vacío.</p>';
    const ups = P.filter(x => x.cheap && x.available !== false && !cart.some(c => c.id === x.id));
    cartUpsell.innerHTML = ups.length ? `<div class="upsell__head">Suma uno más a tu pedido · pruébatelos</div><div class="upsell__list">` +
      ups.map(u => `<div class="ups"><img src="${u.img}" alt=""><div class="ups__b"><b>${u.title}</b><span>${clp(u.price)}</span></div><div class="ups__btns"><button class="ups__try" data-try="${u.id}">Probar</button><button class="ups__add" data-id="${u.id}">+ Agregar</button></div></div>`).join('') + `</div>` : '';
    cartUpsell.querySelectorAll('.ups__add').forEach(b => b.addEventListener('click', (e) => { e.stopPropagation(); const up = P.find(x => x.id === +b.dataset.id); if (up) addToCart(up, up.price); renderCart(); }));
    /* ups__try usa data-try → lo maneja el handler universal (no duplicamos) */
    $('#cartTotal').textContent = clp(cart.reduce((s, i) => s + i.price * i.qty, 0));
    $('#cartCheckout').href = checkoutUrl();
    saveCart();
  }
  // expuesto para el quick try-on (tryon.js)
  window.solarAddToCart = (id) => { const p = P.find(x => x.id === id); if (p) { addToCart(p, p.price); renderCart(); } };
  window.solarOpenCart = openCart;
  /* ── COMPRAR AHORA: agrega el producto a la cart REAL de Shopify y salta DIRECTO al pago.
     - En la tienda (solarcompany.cl, mismo origen): POST a /cart/add.js → redirige a /checkout.
     - En preview estático (Vercel, cross-origin): permalink de Shopify (item listo para pagar). ── */
  window.solarBuyNow = window.solarBuyNow || function (prod) {
    if (!prod) return;
    const vid = prod.vid, qty = prod.qty || 1;
    if (!vid) {
      if (prod.id != null && window.solarAddToCart) window.solarAddToCart(prod.id);
      if (window.solarOpenCart) window.solarOpenCart();
      return;
    }
    const host = location.hostname;
    const onShop = host === 'solarcompany.cl' || host === 'www.solarcompany.cl';
    if (onShop) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: qty }) })
        .then(() => { location.href = '/checkout'; })
        .catch(() => { location.href = 'https://solarcompany.cl/cart/' + vid + ':' + qty; });
    } else {
      location.href = 'https://solarcompany.cl/cart/' + vid + ':' + qty;
    }
  };
  /* ── HANDLER UNIVERSAL de TARJETAS — corre en TODAS las páginas (home, colección, producto).
     Maneja: probar (try-on), agregar al carrito, y el toque/click en la foto.
     Las tarjetas de colección traen los datos en data-* por si no están en el catálogo curado. ── */
  const canHover = matchMedia('(hover:hover)').matches;
  document.addEventListener('click', (e) => {
    const tryB = e.target.closest('[data-try]');
    if (tryB) { e.preventDefault(); if (window.solarQuickTryOn) window.solarQuickTryOn(+tryB.dataset.try); return; }
    const addB = e.target.closest('[data-add]');
    if (addB) {
      e.preventDefault();
      let prod = P.find(x => x.id === +addB.dataset.add);
      if (!prod && addB.dataset.vid) prod = { id: +addB.dataset.add, vid: +addB.dataset.vid, title: addB.dataset.title || '', img: addB.dataset.img || '', price: +addB.dataset.price || 0, cheap: addB.dataset.cheap === '1' };
      if (prod) { addToCart(prod, prod.price || 0); openCart(); }
      return;
    }
    /* COMPRAR AHORA (tarjetas / página de producto Shopify): salta directo al pago.
       Si está dentro de un <form> con selector de variante, usa la variante elegida. */
    const buyB = e.target.closest('[data-buy]');
    if (buyB) {
      e.preventDefault();
      let vid = buyB.dataset.buy;
      const form = buyB.closest('form');
      const sel = form && form.querySelector('[name="id"]');
      if (sel && sel.value) vid = sel.value;
      if (vid) window.solarBuyNow({ vid: +vid });
      return;
    }
    /* toque/click en la foto de la tarjeta:
       - Desktop (hover): navega al producto.
       - Móvil/táctil: el 1er toque REVELA los botones (Ver/Probar/Carrito), el 2º toque navega.
         Así se ve limpio: las acciones NO aparecen hasta tocar la foto. */
    const media = e.target.closest('.card__media');
    if (media && !e.target.closest('.card__act')) {
      const card = media.closest('.card');
      const href = media.dataset.href || (card.querySelector('.card__view') && card.querySelector('.card__view').getAttribute('href')) || (card.querySelector('.card__info') && card.querySelector('.card__info').getAttribute('href'));
      if (canHover) { if (href) location.href = href; }
      else if (card.classList.contains('show')) { if (href) location.href = href; }
      else { card.classList.add('show'); }
    }
  });

  /* ── PRECIOS REALES DESDE SHOPIFY (fuente confiable) ──
     all_products/SOLAR_LIVE entrega precios VIEJOS cacheados (desajuste foto vs carrito/checkout).
     /products.json devuelve los precios REALES actuales de Shopify en una sola llamada → los aplicamos
     a todos los productos del catálogo y re-renderizamos. (Mismo dominio = solo corre en la tienda real.) */
  function applyRealPrices(map) {
    P.forEach(prod => {
      const m = map[prod.handle];
      if (m) {
        prod.price = m.price;
        prod.compareAt = m.compareAt;
        if (typeof m.available === 'boolean') prod.available = m.available;
        if (m.vid) prod.vid = m.vid;
        prod._s = null; /* invalidar texto de búsqueda cacheado (por si cambia algo) */
      }
    });
    if (render) render(true);
    if (opticaRerender) opticaRerender();
    renderCart();
  }
  fetch('/products.json?limit=250')
    .then(r => r.ok ? r.json() : null)
    .then(data => {
      if (!data || !Array.isArray(data.products)) return;
      const map = {};
      data.products.forEach(p => {
        const v = (p.variants || [])[0];
        if (!v) return;
        map[p.handle] = {
          price: Math.round(parseFloat(v.price) || 0),
          compareAt: Math.round(parseFloat(v.compare_at_price) || 0),
          available: v.available,
          vid: v.id
        };
      });
      applyRealPrices(map);
    })
    .catch(() => {});

  /* ── NEWSLETTER ── */
  const newsletterEl = $('#newsletter');
  if (newsletterEl) newsletterEl.addEventListener('submit', e => {
    e.preventDefault(); $('#newsNote').textContent = '✓ Estás dentro. Nos vemos en el próximo drop.'; e.target.reset();
  });

  /* ── REVEAL SYSTEM ── */
  function revealSystem() {
    const sel = '.kicker,.h-display,.optica__lead,.optica__features article,.tryon__intro>*,.ocasion__head,.cta__form,.cta__note,.manifesto__stats';
    const els = $$(sel).filter(el => !el.closest('.hero'));
    els.forEach(el => el.classList.add('rv'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
    setTimeout(() => els.forEach(el => el.classList.add('in')), 2500);
  }

  /* ── BOOT ── */
  function boot() {
    if (loader) loader.classList.add('done');
    document.documentElement.style.overflow = '';
    document.body.classList.add('ready');
    if (render) render(true); /* solo en la home (catálogo) */
    initScroll();
  }

  function initScroll() {
    let lenis;
    if (window.Lenis && !reduce) {
      lenis = new Lenis({ duration: 1.1, smoothWheel: true }); window.__lenis = lenis;
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); }; requestAnimationFrame(raf);
      $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
        const id = a.getAttribute('href'); if (id.length > 1 && $(id)) { e.preventDefault(); lenis.scrollTo(id, { offset: -10 }); }
      }));
    }
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      if (lenis) lenis.on('scroll', ScrollTrigger.update);
      gsap.to('.hero__img', { yPercent: 14, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
      revealSystem();
      const mt = $('.manifesto__text');
      if (mt) {
        mt.innerHTML = mt.textContent.trim().split(/\s+/).map(w => `<span class="word">${w}</span>`).join(' ');
        gsap.to('.manifesto__text .word', { className: 'word lit', stagger: .03, scrollTrigger: { trigger: mt, start: 'top 80%', end: 'bottom 60%', scrub: true } });
      }
      $$('[data-count]').forEach(el => {
        const to = +el.dataset.count;
        ScrollTrigger.create({ trigger: el, start: 'top 90%', once: true, onEnter: () =>
          gsap.fromTo(el, { innerText: 0 }, { innerText: to, duration: 1.6, ease: 'power2.out', snap: { innerText: 1 }, onUpdate() { el.textContent = Math.round(el.innerText); } }) });
      });
      $$('.col-card img').forEach(img => gsap.fromTo(img, { scale: 1.12 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: img, start: 'top 95%', end: 'bottom 30%', scrub: true } }));
      addEventListener('load', () => ScrollTrigger.refresh());
      setTimeout(() => ScrollTrigger.refresh(), 1500);
    } else {
      revealSystem();
    }
  }

})();
